import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function DocBox({ attributes, docSections, multiDocs, articlesNumber }) {
    const { col, docs_layout, sectionsNumber, parent_docs_order, orderBy, child_docs_order } = attributes;

    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    // Fetch child docs for all sections
    const sectionDocs = useSelect((select) => {
        const parentIds = [...(docSections || []), ...(multiDocs || [])].map((section) => section.id);
        const docsBySection = {};
        
        parentIds.forEach((parentId) => {
            docsBySection[parentId] = select("core").getEntityRecords("postType", "docs", {
                per_page: sectionsNumber,
                orderby: orderBy,
                order: parent_docs_order,
                parent: parentId,
                status: ['publish', 'private']
            });
        });

        return docsBySection;
    }, [docSections, multiDocs, sectionsNumber, parent_docs_order, orderBy]);

    // Component for fetching and displaying child items
    function ChildItems({ parentId }) {
        const childItems = useSelect((select) => {
            return select("core").getEntityRecords("postType", "docs", {
                per_page: articlesNumber,
                orderby: orderBy,
                order: child_docs_order,
                parent: parentId,
                status: ['publish', 'private']
            });
        }, [articlesNumber, parentId, child_docs_order, orderBy]);

        return (
            <ul className="navbar-nav docs-single5-nav-wrap ezd-list-unstyled">
                {(childItems && childItems.length > 0 &&
                    childItems.map((child) => (
                        <li key={child.id}>
                            <a href="#">{child.title.rendered}</a>
                        </li>
                    ))
                )}
            </ul>
        );
    }

    return (
        <div className={layoutType}>
            {(docSections || multiDocs) &&
                [...(docSections || []), ...(multiDocs || [])].map((section) => {
                    const docItems = sectionDocs[section.id] || [];

                    return (
                        <div className="docs-box-item docs-single-5-wrap doc-box-style" key={section.id}>
                            <h5 className="docs-5-title">{section.title.rendered}</h5>

                            <div className="dox5-section-item">
                                {docItems.map((item) => (
                                    <div className="section5-article" key={item.id}>
                                        <div className="section5-section-title">
                                            <h6 className="ct-content-text">{item.title.rendered}</h6>
                                        </div>

                                        {/* Fetch and display child items for the current item */}
                                        <ChildItems parentId={item.id} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}